// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SetProductCatalogueVersionRequest
 */
export interface SetProductCatalogueVersionRequest {
  /**
   * The product catalogue version to move the billing account onto. Must be a version published by the product catalogue, or "latest".
   *
   * @type {string}
   * @memberof SetProductCatalogueVersionRequest
   */
  productCatalogueVersion: string;
  /**
   * Why the version is being changed. Recorded on the billing account.
   * @type {string}
   * @memberof SetProductCatalogueVersionRequest
   */
  reason: string;
}

/**
 * Check if a given object implements the SetProductCatalogueVersionRequest interface.
 */
export function instanceOfSetProductCatalogueVersionRequest(
  value: object,
): value is SetProductCatalogueVersionRequest {
  if (
    !('productCatalogueVersion' in value) ||
    value['productCatalogueVersion'] === undefined
  )
    return false;
  if (!('reason' in value) || value['reason'] === undefined) return false;
  return true;
}

export function SetProductCatalogueVersionRequestFromJSON(
  json: any,
): SetProductCatalogueVersionRequest {
  return SetProductCatalogueVersionRequestFromJSONTyped(json, false);
}

export function SetProductCatalogueVersionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetProductCatalogueVersionRequest {
  if (json == null) {
    return json;
  }
  return {
    productCatalogueVersion: json['productCatalogueVersion'],
    reason: json['reason'],
  };
}

export function SetProductCatalogueVersionRequestToJSON(
  json: any,
): SetProductCatalogueVersionRequest {
  return SetProductCatalogueVersionRequestToJSONTyped(json, false);
}

export function SetProductCatalogueVersionRequestToJSONTyped(
  value?: SetProductCatalogueVersionRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    productCatalogueVersion: value['productCatalogueVersion'],
    reason: value['reason'],
  };
}
